<template>
    <div class="wrapper">
        <swiper :options="swiperOption">
            <swiper-slide v-for="(item, index) in swiperList" :key="item.id">
                <img :src="item.image" width="100%" class="swiper_img" />
            </swiper-slide>
            <div class="swiper-pagination"  slot="pagination"></div>
        </swiper>
    </div>
</template>

<script>
import banner01 from '@/assets/img/banner01.jpg'
import banner02 from '@/assets/img/banner02.jpg'
export default {
    name:'HomeSwiper',
    props:{
        swiperList:Array
    },
    data () {
        return {
            isLoading:true,
            images:[
                banner01,
                banner02
            ],
            swiperOption:{
                pagination: '.swiper-pagination',
                autoplay:5000,
                grabCursor: true,
                loop: true
            }
        }
    },
    computed: {
        
    },
    mounted() {
        this.isLoading = false;
    },
}
</script>

<style lang="stylus" scoped>
@media all and (orientation : landscape)
    .wrapper >>> .swiper-container
        z-index: 0 !important
    .wrapper >>> .swiper-pagination-bullet-active
        background #d2a852
    .wrapper
        position: relative
        z-index: 0
        width 100%
        height 0
        padding-bottom 15.625%
        background #ccc
        .swiper_img
            width 100%
@media all and (orientation : portrait)
    .wrapper >>> .swiper-pagination-bullet-active
        background #d2a852
    .wrapper
        overflow hidden
        width 100%
        height 0
        padding-bottom 15.625%
        background #ccc
        .swiper_img
            width 100%
</style>